// 全局错误边界：单个视图异常不拖垮整个应用
import { Component, type ReactNode } from 'react'

interface Props { children: ReactNode }
interface State { error: string | null }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(err: unknown): State {
    return { error: err instanceof Error ? err.message : String(err) }
  }

  render() {
    if (this.state.error) {
      return (
        <div className="empty">
          <div className="big">⚠</div>
          <p>{this.state.error}</p>
          <button className="btn btn-ghost" onClick={() => this.setState({ error: null })}>重试 / Retry</button>
        </div>
      )
    }
    return this.props.children
  }
}
